// src/components/Modal.js
import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    // Main overlay
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      {/* Modal container */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm">
        {/* Modal content is passed in as children */}
        {children}
      </div>
    </div>
  );
};

export default Modal;